import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-900">
            按分类吃瓜
          </h2>
          <p className="text-foreground-600 text-sm mt-2">选择你感兴趣的爆料类型</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 rounded-lg bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50 border border-background-200/70 group-hover:bg-primary-500 group-hover:border-primary-500 group-hover:text-background-50 transition-all text-foreground-700 text-xl">
                <i className={cat.icon}></i>
              </span>
              <span className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-[11px] text-foreground-500 text-center leading-tight">
                {cat.description}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}